import React, { useMemo, useState } from 'react';
import {
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import MyTableBoldCell from '../../../components/material-ui/adaptive/MyTableBoldCell';
import { useTranslation } from 'react-i18next';
import { getFormatDate } from '../../../utils';
import CusTooltip from '../../../components/material-ui/CusTooltip';
import { useAppSelector } from '../../../store';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import CusLink from '../../../components/material-ui/CusLink';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import CurrencyValue from '../../../components/material-ui/CurrencyValue';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import CusSort from '../../../components/material-ui/CusSort';
import { ENUM_SORT_DIRECTION } from '../../../enums/enums';
import useSorting from '../../../hooks/useSorting';
import ShowContentWitchEmpty from '../../../components/material-ui/show_content_empty/ShowContentWitchEmpty';
import LoaderContainer from '../../../components/material-ui/loader_container/LoaderContainer';

/**
  701,				// 0 - идентификатор игрока
  "tg_Кайф_",			// 1 - логин игрока
  "2026-03-03 18:52:01",	// 2 - дата и время регистрации
  "",				// 3 - дата и время первого депозита
  0,				// 4 - сумма первого депозита
  0,				// 5 - количество повторных депозитов
  0,				// 6 - сумма повторных депозитов
  1300,				// 7 - общая сумма начисленных бонусов
  5100,				// 8 - общая сумма отыгранных бонусов
  0,				// 9 - общая сумма выплат
  176305,			// 10 - сумма сделанных ставок
  2185,				// 11 - количество сделанных спинов
  2315632,			// 12 - сумма выигрышей в играх
  0,				// 13 - сумма отыгранных депозитов
  0,				// 14 - сумма комиссии шлюза за депозиты
  0,				// 15 - сумма комиссии шлюза за вывод
  -104437.5,			// 16 - сумма стоимости игр
  "2026-03-18 08:33:30",	// 17 - дата и время последней активности игрока
  0,				// 18 - GGR
  104437.5			// 19 - NGR
 */

export default function TableGamers({ beginValueIndex, loader, empty }) {
  const { t } = useTranslation();
  const { sortNumeric, sortText, sortDate } = useSorting();
  const gamers = useAppSelector((state) => state.reports.gamers.list);
  const currency = useAppSelector((state) => state.reports.gamers.payload.currency);

  const ValueWitchCurrency = ({ value }) => (
    <CurrencyValue justifyContent={'end'} value={value} currency={currency} fontSize={12} />
  );

  const MyHeadCell = ({ text, children, name, sx, isSort }) => (
    <MyTableBoldCell isLess sx={sx}>
      <Stack direction={'row'} gap={0.5} alignItems={'center'} minWidth={80}>
        <Typography fontSize={12} fontWeight={600} lineHeight={'110%'}>
          {children || t(text)}
        </Typography>
        {/* {isSort && (
          <CusSort
            name={name}
            type={sortConfig.key == name ? sortConfig.direction : null}
            setSortConfig={setSortConfig}
          />
        )} */}
      </Stack>
    </MyTableBoldCell>
  );

  // const sortKey = sortConfig.key;
  // const sortDirection = sortConfig.direction;

  // const gamerList = useMemo(() => {
  //   if (sortKey == 'gamer') return sortNumeric(gamers, 0, sortDirection);
  //   if (sortKey == 'regDate') return sortDate(gamers, 2, sortDirection);
  //   if (sortKey == 'firstDepositDate') return sortDate(gamers, 3, sortDirection);
  //   if (sortKey == 'firstDepositAmount') return sortNumeric(gamers, 4, sortDirection);
  //   if (sortKey == 'repeatDepositCount') return sortNumeric(gamers, 5, sortDirection);
  //   if (sortKey == 'repeatDepositAmount') return sortNumeric(gamers, 6, sortDirection);
  //   if (sortKey == 'issuedBonusAmount') return sortNumeric(gamers, 7, sortDirection);
  //   if (sortKey == 'wageredBonusAmount') return sortNumeric(gamers, 8, sortDirection);
  //   if (sortKey == 'totalDepositAmount') return sortNumeric(gamers, 9, sortDirection);
  //   if (sortKey == 'gameBetAmount') return sortNumeric(gamers, 10, sortDirection);
  //   if (sortKey == 'gameSpinCount') return sortNumeric(gamers, 11, sortDirection);
  //   if (sortKey == 'GGR') return sortNumeric(gamers, 18, sortDirection);
  //   if (sortKey == 'NGR') return sortNumeric(gamers, 19, sortDirection);
  //   if (sortKey == 'lastAction') return sortDate(gamers, 17, sortDirection);

  //   return gamers;
  // }, [sortKey, sortDirection, gamers]);

  return (
    <LoaderContainer loader={loader} isBox>
      <ShowContentWitchEmpty
        condition={gamers.length}
        conditionPlug={empty}
        plugText="No entries found. Try changing the filters.">
        <Stack>
          <TableContainer>
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow>
                  <MyTableBoldCell isLess>{t('#')}</MyTableBoldCell>
                  <MyHeadCell text="Gamer" name="gamer" isSort />
                  <MyHeadCell text="Registration date" name="regDate" isSort />
                  <MyHeadCell text="First deposit date" name="firstDepositDate" isSort />
                  <MyHeadCell text="Amount of the first deposit" name="firstDepositAmount" isSort />
                  <MyHeadCell text="Number of repeat deposits" name="repeatDepositCount" isSort />
                  <MyHeadCell text="Amount of repeat deposits" name="repeatDepositAmount" isSort />
                  <MyHeadCell text="Average deposit" name="averageDeposit" />
                  <MyHeadCell text="Amount of bonuses" name="issuedBonusAmount" isSort />
                  <MyHeadCell text="Amount of wagered bonuses" name="wageredBonusAmount" isSort />
                  <MyHeadCell text="Sum of all deposits" name="totalDepositAmount" />
                  <MyHeadCell text="Sum of all payments" name="payoutAmount" />
                  <MyHeadCell text="Sum of all bets" name="gameBetAmount" />
                  <MyHeadCell text="Number of spins" name="gameSpinCount" />
                  <MyHeadCell text="Average bet cost" name="averageBet" />
                  <MyHeadCell text="Player RTP" name="playerRTP" />
                  <MyHeadCell name="GGR" isSort>
                    <Stack direction={'row'} justifyContent={'end'} width={65}>
                      <Typography fontSize={12} fontWeight={600}>
                        <CusTooltip text={'GGR = sum of all deposits - sum of all payments'} />
                        {t('GGR')}
                      </Typography>
                    </Stack>
                  </MyHeadCell>
                  <MyHeadCell name="NGR" isSort>
                    <Stack direction={'row'} justifyContent={'end'} width={65}>
                      <Typography fontSize={12} fontWeight={600}>
                        <CusTooltip
                          text={
                            'NGR = total deposits - gateway deposit fee - player withdrawal amount - gateway withdrawal fee - game rental cost'
                          }
                        />
                        {t('NGR')}
                      </Typography>
                    </Stack>
                  </MyHeadCell>
                  <MyHeadCell name="lastAction" text={'Last action date'} isSort />
                </TableRow>
              </TableHead>
              <TableBody>
                {gamers.map((gamerInfo, indx) => {
                  const playerId = gamerInfo[0];
                  const dateRegister = getFormatDate(gamerInfo[2]);
                  const dateFirstDep = getFormatDate(gamerInfo[3]);
                  const firstDepositAmount = gamerInfo[4];
                  const repeatDepositAmount = gamerInfo[6];
                  const repeatDepositCount = gamerInfo[5];
                  const totalBet = gamerInfo[10];
                  const countSpin = gamerInfo[11];
                  const totalWin = gamerInfo[12];
                  const lastDate = getFormatDate(gamerInfo[17]);

                  const totalDepositAmount = firstDepositAmount + repeatDepositAmount;
                  const totalDepositCount = (firstDepositAmount > 0 ? 1 : 0) + repeatDepositCount;

                  const averageDep =
                    totalDepositCount > 0 ? totalDepositAmount / totalDepositCount : 0;
                  const totalDeposit = firstDepositAmount + repeatDepositAmount;
                  const averageBet = countSpin > 0 ? totalBet / countSpin : 0;

                  const RTP = totalBet > 0 ? ((totalWin / totalBet) * 100).toFixed(2) : '0.00';

                  return (
                    <TableRow
                      key={beginValueIndex + indx}
                      sx={{ '&:hover': { backgroundColor: 'action.hover' } }}>
                      <MyTableCell isLess>{beginValueIndex + indx}</MyTableCell>
                      <MyTableCell isLess>
                        <CusLink to={`/users/finance/${playerId}/${currency}`}>
                          <TypographyText>
                            {playerId}; {gamerInfo[1]}
                          </TypographyText>
                        </CusLink>
                      </MyTableCell>
                      <MyTableCell isLess>{dateRegister}</MyTableCell>
                      <MyTableCell isLess>{dateFirstDep}</MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={firstDepositAmount} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        {repeatDepositCount}
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={repeatDepositAmount} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={averageDep} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={gamerInfo[7]} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={gamerInfo[8]} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={totalDeposit} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={gamerInfo[9]} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={totalBet} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        {countSpin}
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        <ValueWitchCurrency value={averageBet} />
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        {RTP}
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        {gamerInfo[18]}
                      </MyTableCell>
                      <MyTableCell isLess type="numeric">
                        {gamerInfo[19]}
                      </MyTableCell>
                      <MyTableCell isLess>{lastDate}</MyTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </ShowContentWitchEmpty>{' '}
    </LoaderContainer>
  );
}
